<template>
  <el-container>
    <el-header class="header">
      <Header></Header>
    </el-header>
    <el-main ref="scroll">
      <transition name="fade-transform" mode="out-in">
        <router-view></router-view>
      </transition>
    </el-main>
    <BackTop v-show="showBackTop" @click.native="backTop"/>
  </el-container>
</template>

<script type="text/ecmascript-6">
import Header from 'components/Layout/Content/Header'
import BackTop from 'components/BackTop'
let minus
let scrollIt
export default {
  mounted() {
    let scroll = this.$refs.scroll.$el
    scroll.addEventListener('scroll', this.handleScroll)
  },
  data () {
    return {
      showBackTop: false
    }
  },
  methods: {
    handleScroll() {
      let scroll = this.$refs.scroll.$el

      if (scrollIt) {
        clearTimeout(scrollIt)
      }
      scrollIt = setTimeout(() => {
        if (scroll.scrollTop > 100) {
          this.showBackTop = true
        } else {
          this.showBackTop = false
        }
      }, 20)
    },
    backTop() {
      let scroll = this.$refs.scroll.$el
      minus = setTimeout(() => {
        if (scroll.scrollTop < 1) {
          clearTimeout(minus)
        } else {
          scroll.scrollTop = scroll.scrollTop / 2
          this.backTop()
        }
      }, 20)
    }
  },
  components: {
    Header,
    BackTop
  },
  beforeDestroy() {
    let scroll = this.$refs.scroll.$el
    scroll.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">

.el-header,
.el-main
  padding 0
</style>
